import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

void i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'th'],
    defaultNS: 'common',
    ns: [
      'common',
      'auth',
      'onboarding',
      'dashboard',
      'processes',
      'documents',
      'ncr',
      'kpi',
      'qms-planning',
      'organization',
      'risks',
      'audits',
      'training',
      'settings',
      'lessons-learned',
      'suppliers',
      'equipment',
      'inspections',
      'complaints',
      'changes',
      'reviews',
      'design',
      'ai',
      'notifications',
      'import',
      'reports',
    ],
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'flowqms_language',
    },
  });

export default i18n;
